import { useQuery } from 'react-query';

import { getCacheSettings } from 'common/helpers';
import { ISelectModel } from 'common/models';
import API from 'services/api';

const ROOT_UNIT_OF_MEASURES = 'ROOT_UNIT_OF_MEASURES';

export const getUnitMeasures = (): Promise<ISelectModel<number>[]> =>
  API.get('/api/accommodation/unit-measures').then(response => response.data);

export const useUnitOfMeasuresQuery = () => {
  const { data: unitOfMeasures, ...rest } = useQuery(
    ROOT_UNIT_OF_MEASURES,
    getUnitMeasures,
    getCacheSettings(),
  );

  return {
    ...rest,
    unitOfMeasures,
  };
};
